import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import HairTransplantSection from "./components/HairTransplantSection";
import BeforeAfterSection from "./components/BeforeAfterSection";
import AboutSection from "./components/AboutSection";
import TestimonialsSection from "./components/TestimonialsSection";
import GoogleReviewsSection from "./components/GoogleReviewsSection";
import AppointmentSection from "./components/AppointmentSection";
import CTASection from "./components/CTASection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import ChatBot from "./components/ChatBot";
import WhatsAppButton from "./components/WhatsAppButton";
import AdminDashboard from "./components/AdminDashboard";

function HomePage() {
  return (
    <div className="min-h-screen bg-[#FAFAFA] font-manrope" data-testid="app-root">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <HairTransplantSection />
        <BeforeAfterSection />
        <AboutSection />
        <GoogleReviewsSection />
        <CTASection />
        <TestimonialsSection />
        <AppointmentSection />
        <ContactSection />
      </main>
      <Footer />
      <ChatBot />
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/dashboard-admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
